import { Component, OnInit } from '@angular/core';
import { FinanceService } from '../../core/services/finance.service';
import { TaxType } from 'src/app/entity/Tax.interface';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss'],
})
export class FinanceComponent implements OnInit {
  abc = {};
  finance = [{}];
  defaultDateRange = '';
  orderTotal = '';
  closingBalance = '';
  orderCommission = '';
  orderNetMerchandiseValue = '';
  orderProcessingFee = '';
  orderVat: string = '0.00';
  orderSscl: string = '0.00';
  refundCommission = '';
  refundNetMerchandiseValue = '';
  refundProcessingFee = '';
  refundTotal = '';
  refundVat: string = '0.00';
  refundSscl: string = '0.00';
  period = '';
  createObj = {};
  taxDetails: TaxType[] 

  constructor(private financeService: FinanceService) {}
  /*########### Form ###########*/

  ngOnInit(): void {
    this.financeService.range().subscribe((data) => {
      this.period = data['content'].periodData;

      if (this.period.length > 0) {
        this.defaultDateRange = data['content'].periodData[0];
        this.financecall(this.defaultDateRange);
      }
    });
  }
  changeCity(formTo) {
    const getfromval = formTo.split(',')[0];
    const gettoval = formTo.split(',')[1];

    this.createObj = {
      from: getfromval,
      to: gettoval,
    };
    this.financecall(this.createObj);
  }

  twodecimal(amount) {
    const numb = (Math.round(amount * 100) / 100)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numb;
  }

  financecall(fromTo) {
    this.financeService.finance(fromTo).subscribe((data) => {
      this.orderTotal = data['content'].orderTotal;
      this.closingBalance = data['content'].closingBalance;
      this.orderCommission = data['content'].orderCommission;
      this.orderNetMerchandiseValue = data['content'].orderNetMerchandiseValue;
      this.orderProcessingFee = data['content'].orderProcessingFee;
      this.refundCommission = data['content'].refundCommission;
      this.refundNetMerchandiseValue = data['content'].refundNetMerchandiseValue;
      this.refundProcessingFee = data['content'].refundProcessingFee;
      this.refundTotal = data['content'].refundTotal;
      this.taxDetails = data['content'].taxRates;
    });
  }

}
